import React from 'react';
import styles from './Heading.scss';

export const Heading = ({ label }: { label: string }) => {
  return <h4 className={styles.heading}>{label}</h4>;
};
